import { mergeMap } from 'rxjs/operators';
import { IEpic, isTypeOfAndGetPayload } from '@cbridge-utils/redux-observable';
import { downloadFileFromResponse } from '@cbridge-utils/file';
import { toApiSort } from '@cbridge-utils/datagrid';
import { catchApiError, IClientApiDependencySegment } from '@cbridge-packages/api';
import { createApiErrorNotification } from '@cbridge-packages/notification';
import { SymbolSyntheticAction } from '../symbolSynthetic.action';

type IDependencies = IClientApiDependencySegment;

export const exportSymbolSyntheticsEpic: IEpic<{}, IDependencies> = (action$, _, dependencies) => action$.pipe(
  isTypeOfAndGetPayload(SymbolSyntheticAction.exportFile.started),
  mergeMap((params) => {
    const { symbolGroup, search, sort } = params;
    return dependencies.api.exportSyntheticSymbols({ symbolGroup, search, sort: toApiSort(sort) }).pipe(
      mergeMap((response) => {
        downloadFileFromResponse(response);
        return [];
      }),
      catchApiError((error) => {
        return [
          SymbolSyntheticAction.exportFile.failed({ params, error }),
          createApiErrorNotification(error),
        ];
      }),
    );
  }),
);
